import Axios from 'axios';

import APITools from './APITools';

export interface grade {
  userId: string
  name: string
  grade: any
  updateTime: string
  state: string
}

export interface grades {
  [title: string]: grade[]
}

class Report {
  grades: grades;

  constructor(props = {} as Report) {
    this.grades = props.grades;
  }

  static async getAll(params: {
    courseID: string;
  }): Promise<grades> {
    const queryString = APITools.parseQueryParams(params);
    const { data } = await Axios.get(`/classroom/courses/course-work/student-submission/grades${queryString}`);
    return data;
  }
}

export default Report;
